import React, { useContext, useEffect, useRef } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { PbiReportViewer } from './PbiReportViewer';
import { NavDataContext } from 'layouts/main-content/MainContent';
import { hasPbiReportId } from './hasReportId';
import { getActiveReport } from 'layouts/functions/getActiveReport';

type PbiReportsType = {
  activeProjectKey: string;
};

export const PbiReports: React.FC<PbiReportsType> = ({ activeProjectKey }) => {
  const { reportId } = useParams();
  const navData = useContext(NavDataContext);
  const location = useLocation();

  // Use ref to track if we've already sent the GA event for this report
  const sentGARef = useRef<string | null>(null);

  useEffect(() => {
    if (!reportId || !activeProjectKey || !navData?.children?.length) return;

    const reportExists = hasPbiReportId(navData, reportId);
    if (!reportExists) return;

    const activeReport = getActiveReport({
      navData,
      pathname: location.pathname,
      defaultId: 'home_page',
    });
    if (!activeReport?.name) return;

    // Only send GA event when the report changes and hasn't been sent yet
    if (reportId && reportId !== sentGARef.current) {
      ReactGA.send({
        hitType: 'pageview',
        page: `/reports/pbi/${reportId}`,
        title: `PBI: ${activeReport.name}`,
      });

      sentGARef.current = reportId;
    }
  }, [reportId, activeProjectKey, navData, location.pathname]);

  if (!reportId || !activeProjectKey || !navData?.children?.length)
    return <p>Report not found</p>;

  const reportExists = hasPbiReportId(navData, reportId);
  if (!reportExists) return <p>Report not found</p>;

  const activeReport = getActiveReport({
    navData,
    pathname: location.pathname,
    defaultId: 'home_page',
  });
  if (!activeReport?.name) return <p>Report not found</p>;

  return (
    <PbiReportViewer reportId={reportId} activeProjectKey={activeProjectKey} />
  );
};
